export default __webpack_public_path__ + "9e5054a.png";